import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AddCarUnderBrand, UpdateCarUnderBrand } from '../../../actions'

const AddCar = ({ ID, editData }) => {
    const [carData, setCarData] = useState({
        carName:'',
        carNameAr:'',
        priority:'',
        status: Boolean
    })
    const dispatch = useDispatch()

    useEffect(() => {
        if(editData && Object.keys(editData).length > 0){
            setCarData({
                carName: editData?.name,
                carNameAr: editData?.nameAr,
                priority: editData?.priority,
                status: editData?.status,
            })
        } else {
            setCarData({
                carName:'',
                carNameAr:'',
                priority:'',
                status: true
            })
        }
    },[editData])

    const onChangeHandler = (e) => {
        const{name, value} = e.target
        setCarData({...carData, [name]:value})
    }

    const onSubmitHandler = () => {
        if(editData && Object.keys(editData).length > 0){
            const payload = {
                carModelId: editData?.carModelId,
                name: carData.carName,
                nameAr: carData.carNameAr,
                priority: Number(carData.priority),
                status: carData.status
            }
            dispatch(UpdateCarUnderBrand(payload))
        } else {
            const payload = {
                brandId: ID,
                name: carData.carName,
                nameAr: carData.carNameAr,
                priority: Number(carData.priority),
                status: carData.status
            }
            dispatch(AddCarUnderBrand(payload))
        }
        setCarData({
            carName:'',
            carNameAr:'',
            priority:1,
            status: true
        })
    }
console.log("carData", editData);
  return (
    <div className="modal fade" id="addCarModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">{editData && Object.keys(editData).length > 0 ? 'Update' : 'Add' } Car</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div className="modal-body">
                    <form action="submit">
                    <div className="form-group">
                        <label for="carNameInput">Car Name</label>
                        <input type="text" value={carData?.carName} onChange={onChangeHandler} name='carName' className="form-control" id="carNameInput" aria-describedby="Car Name" placeholder="Enter Car Name" />
                    </div>
                    <div className="form-group">
                        <label for="carNameInput">Car Name Ar</label>
                        <input type="text" value={carData?.carNameAr} onChange={onChangeHandler} name='carNameAr' className="form-control" id="carNameInput" aria-describedby="Car Name Ar" placeholder="Enter Car Name" />
                    </div>
                    <div className="form-group">
                        <label for="carPriority">Priority</label>
                        <input type="number" value={carData?.priority} onChange={onChangeHandler} name='priority' className="form-control" id="carPriority" aria-describedby="Car Priority" placeholder="Priority" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="statusSelect">Status</label>
                        <select className="form-control" value={carData?.status} name='status' onChange={onChangeHandler} id="statusSelect">
                            <option value={true}>Active</option>
                            <option value={false}>Inactive</option>
                        </select>
                    </div>
                    </form>
                </div>
                <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={onSubmitHandler}>{editData && Object.keys(editData).length > 0 ? 'Update' : 'Save'}</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AddCar